import Vue from 'vue'
import VueRouter from 'vue-router'
import ConceptListView from '@/views/ConceptListView.vue';
import ConceptDetailView from '@/views/ConceptDetailView.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'concept-list',
    component: ConceptListView
  },
  {
    path: "/:id",
    name: "concept-detail",
    component: ConceptDetailView
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
